/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { GeneralService } from './services/general.service';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  API: any;

  public listarEntidad(){
    this.API.mostrarEntidad().subscribe(
        (success:any)=>{
            console.log(success);//el success contiene tu respuesta
        },
        (error)=>{
            console.log("algo ocurrio: ",error)
        }
   );
}

  constructor(public _General: GeneralService) {}

  ngOnInit(): void {}

  
}




